import { render } from "./manual-remove-p2p.vue?vue&type=template&id=93d6a5f2"
import script from "./manual-remove-p2p.vue?vue&type=script&lang=js"
export * from "./manual-remove-p2p.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__